import { MoreVertical } from 'lucide-react';
import { memo } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { useGetUserVisit } from '../../../hooks/query/useGetUserVisit';

const COLORS = ['#3b82f6', '#f97316', '#22c55e', '#a855f7', '#ec4899', '#14b8a6'];
type CityVisit = {
    city: string;
    count: number;
};

interface ChartType {
    name: string;
    value: number;
    color: string;
};
function DeviceType() {
    const { data, isLoading } = useGetUserVisit();

    const visitData = data?.data;
    const total = visitData?.total ?? 0;
    const byCity = visitData?.byCity ?? [];

    const chartData = byCity.map((item: CityVisit, index: number) => ({
        name: item.city,
        value: Number(item.count),
        color: COLORS[index % COLORS.length],
    }));

    return (
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-white text-lg font-semibold">Thống kê vị trí của người dùng</h3>
                <MoreVertical className="text-slate-400" size={20} />
            </div>

            {isLoading ? (
                <div className="flex items-center justify-center h-[200px]">
                    <p className="text-slate-400 text-sm">Loading...</p>
                </div>
            ) : (
                <>
                    <ResponsiveContainer width="100%" height={200}>
                        <PieChart>
                            <Pie
                                data={chartData}
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={80}
                                dataKey="value"
                            >
                                {chartData.map((entry: any, index: number) => (
                                    <Cell key={index} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip
                                contentStyle={{ background: '#1e293b', border: 'none', borderRadius: 8 }}
                                labelStyle={{ color: '#94a3b8' }}
                                itemStyle={{ color: '#fff' }}
                            />
                        </PieChart>
                    </ResponsiveContainer>

                    <div className="text-center">
                        <p className="text-3xl font-bold text-white">{total}</p>
                        <p className="text-slate-400 text-sm">Total Visits</p>
                    </div>

                    <div className="space-y-2 mt-4">
                        {chartData.map((item: ChartType, index: number) => (
                            <div key={index} className="flex items-center justify-between text-sm">
                                <span className="flex items-center gap-2 text-slate-400">
                                    <span
                                        className="inline-block w-3 h-3 rounded-sm"
                                        style={{ backgroundColor: item.color }}
                                    />
                                    {item.name}
                                </span>
                                <span className="text-white">
                                    {total > 0 ? Math.round((item.value / total) * 100) : 0}%
                                    <span className="text-slate-500 ml-1">({item.value})</span>
                                </span>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

export default memo(DeviceType);